var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuCuratorshipMonitorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#660099;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,88.6v90.9c0,8.3-7.1,15.2-15.8,15.2c-8.5,0.1-15.7-6.7-15.8-15.2c0,0,0,0,0-0.1v-46.2L329.5,324.7 c-4.3,6-12.3,8.3-19.1,5.3l-182.8-77.8l-98,167.7c-2.8,4.8-8,7.8-13.7,7.7c-2.7,0-5.3-0.6-7.8-1.8c-7.3-3.9-10.1-13-6.2-20.3 c0.1-0.2,0.2-0.4,0.4-0.6l104.9-179.4c4.1-6.9,12.7-9.7,20-6.5l184.1,78.2L451.4,104h-59.8c-8.5,0.1-15.7-6.7-15.8-15.2 c0,0,0,0,0-0.1c0-8.5,7-15.3,15.8-15.3h92.6C492.8,73.4,500,80.1,500,88.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuCuratorshipMonitorBlue);
export default __webpack_public_path__ + "static/media/ic-menu-curatorship-monitor-blue.e3ab6247abed41edad4c70ee0967d285.svg";
export { ForwardRef as ReactComponent };